import React from 'react';
import { Badge } from '../../ui/Badge';
import { ChoiceGroup } from '../ChoiceGroup';
import { billingStepLabel } from '../../../utils/practices';
import { BillingStep, CertificatesStatus, PracticeDraft } from '../../../types/practice';
interface PracticeBillingFieldsProps {
  draft: PracticeDraft;
  onChange: (changes: Partial<PracticeDraft>) => void;
}
export function PracticeBillingFields({
  draft,
  onChange
}: PracticeBillingFieldsProps) {
  const billingRow = (key: 'proforma' | 'invoice', label: string, doneLabel: string) => {
    const value: BillingStep = draft[key];
    return <div className="flex items-center justify-between gap-4 py-3" data-id="element-1318" data-mp="2qz7xdzjfk2r7">
        <label className="flex items-center gap-2 cursor-pointer" data-id="element-1319" data-mp="2m1g697qm0ko2">
          <input type="checkbox" className="rounded border-slate-300 text-seform-orange focus:ring-seform-orange" checked={value !== 'off'}
        // Once generated by the administration it can no longer be removed
        disabled={value === 'fatto'} onChange={e => onChange({
          [key]: e.target.checked ? 'da_fare' : 'off'
        } as Partial<PracticeDraft>)} data-id="element-1320" data-mp="2m3amw9uulqmc" />
          <span className="text-sm font-medium text-slate-700" data-id="element-1321" data-mp="2uwjwqgju2657">{label}</span>
        </label>
        {value !== 'off' && <Badge variant={value === 'fatto' ? 'success' : 'warning'} size="sm" data-id="element-1322" data-mp="2zxpsyocpcbjh">
            {billingStepLabel(value, doneLabel)}
          </Badge>}
      </div>;
  };
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1323" data-mp="2pztgnt813ajs">
      <section data-id="element-1324" data-mp="2c7d8yf46mocj">
        <h3 className="text-sm font-semibold text-seform-navy" data-id="element-1325" data-mp="2c7vey3gncgxn">Fatturazione</h3>
        <p className="text-xs text-slate-500 mt-0.5 mb-2" data-id="element-1326" data-mp="2h6gf62vwf0m3">
          Facoltativa. Spuntando una voce si genera in automatico la posizione
          in Formazione › Fatturazione.
        </p>
        <div className="divide-y divide-slate-100" data-id="element-1327" data-mp="277h7amiyj905">
          {billingRow('proforma', 'Proforma da fare', 'Proformato')}
          {billingRow('invoice', 'Fattura da fare', 'Fatturato')}
        </div>
      </section>
      <section data-id="element-1328" data-mp="1jb42tz30q04p">
        <h3 className="text-sm font-semibold text-seform-navy mb-3" data-id="element-1329" data-mp="1jakvfcazuu4x">Attestati</h3>
        <ChoiceGroup label="Stato attestati" name="practice-certificates" value={draft.certificates} options={[{
        value: 'Da inviare',
        label: 'Da inviare'
      }, {
        value: 'Inviati',
        label: 'Inviati'
      }]} onChange={(v: CertificatesStatus) => onChange({
        certificates: v
      })} data-id="element-1330" data-mp="1edkokz6blncr" />
      </section>
    </div>;
}